<template>
  <div style="height: 100%">
    <iframe :src="'https://view.officeapps.live.com/op/view.aspx?src='+value" frameborder="0" width="100%" height="100%"></iframe>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
};
</script>